import Login from './login/index'
import Home from './home/index'
import user from './authority/user/index'
import role from './authority/role/index'
import menu from './authority/menu/index'
import lookup from './basedata/lookup/index'
import setting from './basedata/setting/index'
export default {
  material: '/common-service/material/list',
  submitLogin: '/authorize-service/guest/login',
  phoneCode: '/authorize-service/guest/phoneCode',
  modifyPassword: '/authorize-service/authorize/service/user/modifyPassword',
  selectLookupItemByCode: '/admission-service/parent/guest/admission/lookup/selectLookupItemByCode',
  registerUser: '/authorize-service/guest/registerUser',
  uploadfile: '/common-service/common/dfs/file',
  delfile: '/common-service/common/dfs/file',
  onlinePreview: '/common-service/office/onlinePreview',
  downloadFileByPath: '/admission-service/admission/application/downloadFileByPath',
  getAppId: '/open-weixin-service/weixin/open/oauth/appId',
  login: Login,
  role: role,
  menu: menu,
  user: user,
  home: Home,
  lookup: lookup,
  setting: setting
}



// WEBPACK FOOTER //
// ./src/config/index.js